@if (variant() === 'icon') {
  <button
    type="button"
    class="menu-trigger-icon"
    #trigger="cdkOverlayOrigin"
    cdkOverlayOrigin
    aria-haspopup="menu"
    [class.is-open]="isOpen"
    [attr.aria-expanded]="isOpen"
    [attr.aria-label]="ariaLabel()"
    (click)="toggleDropdown()"
    (keydown)="onTriggerKeydown($event)">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true">
      <path stroke-linecap="round" stroke-linejoin="round" d="M12 6.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM12 12.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM12 18.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Z" />
    </svg>
  </button>
} @else if (variant() === 'chip') {
  <button
    type="button"
    class="menu-trigger-chip"
    #trigger="cdkOverlayOrigin"
    cdkOverlayOrigin
    aria-haspopup="menu"
    [class.is-open]="isOpen"
    [attr.aria-expanded]="isOpen"
    [attr.aria-label]="ariaLabel()"
    (click)="toggleDropdown()"
    (keydown)="onTriggerKeydown($event)">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true">
      <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
    </svg>
    <span>{{ title() }}</span>
  </button>
} @else {
  <div class="select-trigger" #trigger="cdkOverlayOrigin" cdkOverlayOrigin (click)="toggleDropdown()"
      role="button" tabindex="0" aria-haspopup="menu" [attr.aria-expanded]="isOpen" [attr.aria-label]="ariaLabel()"
      (keydown)="onTriggerKeydown($event)"
      [class.select-trigger-xs]="size() === 'xs'" [class.select-trigger-sm]="size() === 'sm'"
      [class.select-trigger-lg]="size() === 'lg'">
      @if(title()) {
      {{ title() }}
      }
      <ng-content select=".dropdown-icon"></ng-content>
  </div>
}
<ng-template #dropdownTemplate>
    <div class="select-dropdown" #panel role="menu" tabindex="-1" [attr.aria-label]="ariaLabel() || title() || null"
        (keydown)="onPanelKeydown($event)">
        <ng-content></ng-content>
    </div>
</ng-template>
